<div id="comparision-map"
     class="card card--box"
     [class.collapsed]="isCollapsed">
        <perfect-scrollbar #ps>
            <div class="interactive-tasks tasklists--wrapper tasklists--wrapper--symptom card card--box col-md-12">
                <div class="tasklists--wrapper__header">
                    <div class="row">
                        <div class="col-xs-12 tasklists--wrapper__header__compare-date">
                            <span class="selected-date">
                                {{  symptomMapType === 'SE' ? ('Self Evaluation' | translate) : ('Diagnostic Interview compare panel' | translate) }} &bull; {{ formatSelectedCurrentDate }}
                            </span>
                            <span class="icon">
                                <i class="compare-icon"></i>
                            </span>
                            <span class="dropdown">
                                <div class="btn-group dropdown" dropdown>
                                    <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle">
                                        {{  selectedComparisonType === 'SE' ? ('Self Evaluation' | translate) : ('Diagnostic Interview compare panel' | translate) }} &bull; {{ selectedComparisonDate }}
                                    </button>
                                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
                                        <perfect-scrollbar #ps>
                                            <div *ngFor="let comparisonDate of completedDates; let i = index" class="comparison-dropdown">
                                                <li role="menulabel" class="menu-label">
                                                    <span>
                                                        {{ comparisonDate['sequence_text_' + translate.currentLang] }} {{ 'Assessment' | translate }}
                                                    </span>
                                                </li>
                                                <li role="menuitem" *ngIf="comparisonDate.sr_completed_date && comparisonDate.sr_id">
                                                    <div class="dropdown-item" (click)="selectDate(comparisonDate.sr_id, comparisonDate.sr_completed_date, 'SE')" [class.dropdown-item--disabled]="selectedComparisonId === comparisonDate.sr_id || selectedCurrentId === comparisonDate.sr_id">
                                                        <span class="dropdown-item__description">
                                                            {{ 'Self Evaluation' | translate }} &bull; {{comparisonDate.sr_completed_date}}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li role="menuitem" *ngIf="comparisonDate.di_completed_date && comparisonDate.di_id">
                                                    <div class="dropdown-item" (click)="selectDate(comparisonDate.di_id, comparisonDate.di_completed_date, 'DI')" [class.dropdown-item--disabled]="selectedComparisonId === comparisonDate.di_id || selectedCurrentId === comparisonDate.di_id">
                                                        <span class="dropdown-item__description">
                                                            {{ 'Diagnostic Interview compare panel' | translate }} &bull; {{comparisonDate.di_completed_date}}
                                                        </span>
                                                    </div>
                                                </li>
                                            </div>
                                        </perfect-scrollbar>
                                    </ul>
                                </div>
                            </span>
                        </div>
                    </div>
                    <div class="row mr-t--sm mr-b--sm">
                        <div class="col-xs-12">
                            <mat-slide-toggle class="mr-r--xs" [(ngModel)]="filtered.reduced" (change)="filter()">
                                {{ symptomMapType === selectedComparisonType ? ('Reduced compare panel' | translate) : ('Reduced different compare panel' | translate) }} ({{comparisonData?.positive_change.length}})
                            </mat-slide-toggle>
                            <mat-slide-toggle class="mr-r--xs" [(ngModel)]="filtered.new" (change)="filter()" *ngIf="symptomMapType === selectedComparisonType">
                                {{ 'Newly occurred' | translate }} ({{comparisonData?.new_appearance.length}})
                            </mat-slide-toggle>
                            <mat-slide-toggle  [(ngModel)]="filtered.increased" (change)="filter()">
                                {{ symptomMapType === selectedComparisonType ? ('Increased compare panel' | translate) : ('Increased different compare panel' | translate) }} ({{comparisonData?.negative_change.length}})
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <hr>
                </div>
                <div class="tasklists--wrapper__body">
                    <div class="graphic-item">
                        <div class="graphic-item__data">
                            <span class="date">{{ selectedCurrentDate }}</span>
                            <div class="symptom first-child ">
                                <span class="symptom__name"></span>
                                <span class="symptom__circle">
                                    <span class="symptom__circle__divider"></span>
                                    <span class="symptom__circle__left"></span>
                                    <span class="symptom__circle__right"></span>
                                </span>
                            </div>
                            <ng-container *ngFor="let domain of filteredData; let i = index">
                                <div class="domain">
                                    <span class="domain__name" (click)="collapseDomain(domain[0]['domain_name'])">
                                        {{ domain[0]['domain_name'] }}
                                        <i class="mr-l--sm fal fa-angle-up" *ngIf="!isCriteriaCollapsed[domain[0]['domain_name']]"></i>
                                        <i class="mr-l--sm fal fa-angle-down" *ngIf="isCriteriaCollapsed[domain[0]['domain_name']]"></i>
                                    </span>
                                    <span class="domain__circle">
                                        <span class="domain__circle__divider"></span>
                                    </span>
                                </div>
                                <ng-container *ngFor="let item of domain">
                                    <div class="symptom" *ngIf="!isCriteriaCollapsed[domain[0]['domain_name']] && item['type'] !== TYPES.no_change">
                                        <span class="symptom__name">
                                            {{item['symptom_name'] | replace : '#' : ' '}}
                                            <span class="new-label" *ngIf="item['type'] === TYPES.new_appearance">
                                                {{ 'New' | translate}}
                                            </span>
                                        </span>
                                        <ng-container *ngIf="item['type'] === TYPES.negative_change || item['type'] === TYPES.new_appearance">
                                            <span class="symptom__circle {{item['status']}}">
                                                <span class="symptom__circle__divider"></span>
                                                <span class="symptom__circle__compare symptom__circle__compare__negative step-{{item['step']}} {{item['old_status']}}"
                                                    [ngClass]="item['status'] + '-' + item['old_status']">
                                                </span>
                                            </span>
                                        </ng-container>
                                        <ng-container *ngIf="item['type'] === TYPES.hide_on_map">
                                            <span class="symptom__circle hide-on-map">
                                                <span class="symptom__circle__divider"></span>
                                                <span class="symptom__circle__compare symptom__circle__compare__negative step-{{item['step']}} {{item['old_status']}} {{symptomMapType}} hide-on-map">
                                                </span>
                                            </span>
                                        </ng-container>
                                        <ng-container *ngIf="item['type'] === TYPES.positive_change">
                                            <span class="symptom__circle {{item['status']}}">
                                                <span class="symptom__circle__divider"></span>
                                                <span class="symptom__circle__compare symptom__circle__compare__positive step-{{item['step']}} {{item['old_status']}}"
                                                    [ngClass]="item['status'] + '-' + item['old_status']">
                                                </span>
                                            </span>
                                        </ng-container>
                                        <ng-container *ngIf="item['type'] === TYPES.no_change">
                                            <span class="symptom__circle {{item['status']}}">
                                                <span class="symptom__circle__divider"></span>
                                            </span>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <div class="symptom last-child">
                                <span class="symptom__name"></span>
                                <span class="symptom__circle"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
</div>
